import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { createDiaryHooks } from '../factory'
import { deleteEvidenceDiary, downloadEvidenceDiaryPdf, getEvidenceDiaries, getEvidenceDiary, getEvidenceDiaryLog, updateEvidenceDiary } from './functions'
import { EvidenceDiaryLogResponse } from './types'

const evidenceDiary = {
    ...createDiaryHooks('evidenceDiary', {
        getDiaries: getEvidenceDiaries,
        getDiary: getEvidenceDiary,
        updateDiary: updateEvidenceDiary,
        deleteDiary: deleteEvidenceDiary,
        downloadDiaryPdf: downloadEvidenceDiaryPdf,
    }),
    GetEvidenceDiaryLog: {
        useQuery: (id: number | string, options?: Omit<UseQueryOptions<EvidenceDiaryLogResponse, AxiosError>, 'queryKey' | 'queryFn'>) =>
            useQuery({
                queryKey: ['evidenceDiary', 'log', id],
                queryFn: () => getEvidenceDiaryLog(id),
                enabled: !!id,
                staleTime: 0,
                ...options,
            }),
    },
}

export default evidenceDiary
